/* Shared types for Models */
export const IMAGE_UPLOAD_SUPPORTED_MODEL_TYPES = ['image-to-text', 'multimodal-to-text'];
export const TEXT_GEN_MODEL_TYPES = ['text-to-text', ...IMAGE_UPLOAD_SUPPORTED_MODEL_TYPES];
